export default {
  'menu.providerManagement': 'Provider Management',
  'menu.providerManagement.admission': 'Admission Management',
  'menu.providerManagement.admissionApply': 'Apply for Admission',
  'menu.providerManagement.providerCompanies': 'Entity Management',
  'menu.providerManagement.providerCompanyDetail': 'Entity Details',
  'menu.admission': 'Admission Management',
  'menu.admissionApply': 'Apply for Admission',
  'menu.providerCompanies': 'Entity Management',
  'menu.providerCompanyDetail': 'Entity Details',
  'menu.customerManagement': 'Customer Operations',
  'menu.customerManagement.leads': 'Leads',
  'menu.customerManagement.leadDetail': 'Lead Details',
  'menu.customerManagement.customers': 'Enterprise Customers',
  'menu.customerManagement.customerDetail': 'Customer Details',
  'menu.customerManagement.opportunities': 'Service Opportunities',
  'menu.customerManagement.opportunityDetail': 'Opportunity Details',
  'menu.customers': 'Enterprise Customers',
  'menu.customerDetail': 'Customer Details',
  'menu.opportunities': 'Service Opportunities',
  'menu.opportunityDetail': 'Opportunity Details',
  'menu.businessManagement': 'Business Management',
  'menu.businessManagement.products': 'Service Products',
  'menu.businessManagement.products.productCreate': 'New Product',
  'menu.businessManagement.products.productEdit': 'Edit Product',
  'menu.businessManagement.products.productDetail': 'Product Details',
  'menu.businessManagement.orders': 'Service Orders',
  'menu.businessManagement.orders.orderDetail': 'Order Details',
  'menu.products': 'Service Products',
  'menu.productCreate': 'New Product',
  'menu.productEdit': 'Edit Product',
  'menu.productDetail': 'Product Details',
  'menu.orders': 'Service Orders',
  'menu.orderDetail': 'Order Details',
  'menu.projects': 'Service Projects',
  'menu.projectDetail': 'Project Details',
  'menu.serviceQuality': 'Service Quality',
  'menu.serviceQuality.reviews': 'Service Reviews',
  'menu.serviceQuality.qualityImprovements': 'Quality Improvements',
  'menu.reviews': 'Service Reviews',
  'menu.qualityImprovements': 'Quality Improvements',
  'menu.analytics': 'Business Analytics',
  'menu.settings.capabilities': 'Service Capabilities',
  'menu.settings.reviewTags': 'Review Tags',
  'menu.capabilities': 'Service Capabilities',
  'menu.reviewTags': 'Review Tags',
  'menu.workbench': 'Workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'System Settings',
  'menu.settings.permissions': 'Permission Management',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
